"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledSystem = require("styled-system");

var _css = _interopRequireDefault(require("@styled-system/css"));

var _system = _interopRequireDefault(require("../../utils/system"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var propTypes = {
  variant: (0, _propTypes.oneOf)(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'overline', 'inherit']),
  paragraph: _propTypes.bool,
  truncated: _propTypes.bool
};
var defaultProps = {
  variant: 'body1',
  paragraph: false,
  truncated: false
};
var defaultMap = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p',
  caption: 'span',
  overline: 'span'
};
var Typography = (0, _system["default"])('p')({
  label: 'Typography'
}, (0, _css["default"])({
  color: 'text',
  m: 0
}), (0, _styledSystem.variant)({
  scale: 'typography',
  variants: {
    h1: {
      fontFamily: 'heading',
      fontSize: '5xl',
      fontWeight: 'normal',
      lineHeight: 'base'
    },
    h2: {
      fontFamily: 'heading',
      fontSize: '4xl',
      fontWeight: 'normal',
      lineHeight: 'base'
    },
    h3: {
      fontFamily: 'heading',
      fontSize: '3xl',
      fontWeight: 'normal',
      lineHeight: 'base'
    },
    h4: {
      fontFamily: 'heading',
      fontSize: '2xl',
      fontWeight: 'normal',
      lineHeight: 'base'
    },
    h5: {
      fontFamily: 'heading',
      fontSize: 'xl',
      fontWeight: 'normal',
      lineHeight: 'base'
    },
    h6: {
      fontFamily: 'heading',
      fontSize: 'lg',
      fontWeight: 'normal',
      lineHeight: 'base'
    },
    subtitle1: {
      fontFamily: 'body',
      fontSize: 'lg',
      fontWeight: 'bold',
      lineHeight: 'base'
    },
    subtitle2: {
      fontFamily: 'body',
      fontSize: 'lg',
      fontWeight: 'normal',
      lineHeight: 'base'
    },
    body1: {
      fontFamily: 'body',
      fontSize: 'md',
      fontWeight: 'normal',
      lineHeight: 'base'
    },
    body2: {
      fontFamily: 'body',
      fontSize: 'sm',
      fontWeight: 'normal',
      lineHeight: 'base'
    },
    caption: {
      fontFamily: 'body',
      fontSize: 'xs',
      fontWeight: 'normal',
      lineHeight: 'base'
    },
    overline: {
      fontFamily: 'body',
      fontSize: '2xs',
      fontWeight: 'normal',
      lineHeight: 'base'
    },
    inherit: {}
  }
}), function (props) {
  return props.paragraph && (0, _css["default"])({
    mb: 4
  });
}, function (props) {
  return props.truncated && {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  };
});
var Component = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var as = defaultMap[props.variant] || defaultMap.body;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Typography, _objectSpread({
    as: as,
    ref: ref
  }, props));
});
Component.displayName = 'Typography';
Component.propTypes = propTypes;
Component.defaultProps = defaultProps;
var _default = Component;
exports["default"] = _default;

//# sourceMappingURL=Typography.js.map